import { useState } from "react";
import { Tabs } from "../../components";
import OfficeTab from "./OfficesTab";
import DashboardTab from "./DashboardTab";

const AdminFinanceScreen = () => {
  const [activeMainTab, setActiveMainTab] = useState(0);

  const handleMainTabChange = (index: number) => {
    setActiveMainTab(index);
  };

  return (
    <>
      <main
        style={{
          minHeight: "calc(100vh - 96px)",
        }}>
        <div className="container mx-auto p-8 relative">
          <Tabs
            components={[<DashboardTab key={"dash-tab"} />, <OfficeTab key={"office-tab"} />]}
            onClickTab={handleMainTabChange}
            options={["Dashboard", "Offices"]}
            activeTab={activeMainTab}
          />
        </div>
      </main>
    </>
  );
};
export default AdminFinanceScreen;
